import styled from "styled-components";
import { CommonPuppeteerMessage } from "../../types";
import {
  EventBody,
  getMessageComponent,
  MessageComponent,
  MessageComponentProps,
} from "./Message";
import { HighlightedText } from "../../agent/stateComponents/SimpleComponentVisualization";

const PuppeteerMessageContainer = styled.div`
  display: flex;
  gap: 40px;
  align-items: center;
  margin-right: 10px;
`;

const PuppeteerMessageTable = styled.table`
  flex-grow: 1;
`;

const PuppeteerMessageHeader = styled.h6`
  font-size: 14px;
`;

const PuppeteerTableRow = styled.tr<{ $backgroundColor?: string }>`
  background-color: ${({ $backgroundColor }) => $backgroundColor};
  border-bottom: 3px solid white;

  &:last-child {
    border-bottom: none;
  }

  > td {
    padding: 5px;
  }
`;

const PuppeteerMessage: MessageComponent<CommonPuppeteerMessage> = ({
  message,
  textFilter,
}: MessageComponentProps<CommonPuppeteerMessage>) => {
  return (
    <PuppeteerMessageContainer>
      <span>
        <PuppeteerMessageHeader>puppet_id</PuppeteerMessageHeader>
        <code>
          <HighlightedText
            text={message.puppet_id ?? ""}
            textFilter={textFilter}
          />
        </code>
      </span>
      <PuppeteerMessageTable>
        <tbody>
          {message.contents.map((message, index) => {
            const Message = getMessageComponent(message.message_type);
            return (
              <PuppeteerTableRow key={index}>
                <td>
                  <EventBody>
                    <HighlightedText
                      text={message.message_type ?? ""}
                      textFilter={textFilter}
                    />
                  </EventBody>
                </td>
                <td>
                  <Message message={message} textFilter={textFilter} />
                </td>
              </PuppeteerTableRow>
            );
          })}
        </tbody>
      </PuppeteerMessageTable>
    </PuppeteerMessageContainer>
  );
};

export default PuppeteerMessage;
